module.exports = __webpack_public_path__ + "media/images/countryrect/io-b357f2d10d0f9fd3b8e7bb88cb3e727a.svg";